// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3BFCl","label":"LabeledBox_label__19zTP"};